import { doGETRequest, doPUTRequest, doPOSTRequest } from "./Api";

class WaybillApi {

    // İrsaliyeleri listeler
    public static async list(queryFilter: any) {
        const relativePath = "/sales-waybill/list";
        return await doGETRequest(relativePath);
    }

    public static async approve(waybillId: number) {
        const relativePath = `/sales-waybill/approve/${waybillId}`;
        return await doPUTRequest(relativePath, {});
    }

    public static async createLogoOrder(waybillId: number) {
        const relativePath = `/sales-waybill/${waybillId}/create-logo-order`;
        return await doPOSTRequest(relativePath, {});
    }

    public static async createLogoWaybill(waybillId: number) {
        const relativePath = `/sales-waybill/${waybillId}/create-logo-waybill`;
        return await doPOSTRequest(relativePath, {});
    }

   public static async revertShipment(shipmentId: number) {
        const relativePath = `/sales-waybill/revert-shipment/${shipmentId}`;
        return await doPOSTRequest(relativePath, {});
    }

   public static async deleteFromLogo(id: number) {
        const relativePath = `/sales-waybill/${id}/delete-from-logo`;
        return await doPOSTRequest(relativePath, {});
    }
}

export default WaybillApi;